module.exports = __webpack_public_path__ + "static/media/rittal-servicing-visit-9106e5e9e45a4238a5961fa3331b8f3e-signed.66ec9f80.apk";